import { render, staticRenderFns } from "./PersonVault.vue?vue&type=template&id=5e6b9e51"
import script from "./PersonVault.vue?vue&type=script&lang=js"
export * from "./PersonVault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports